module.exports = __webpack_public_path__ + "static/screen_9-e9cfbafe8799b2332ad3ebefe12286a5.png";